import { release as releaseAsset } from "../../runtime/assetCache";
import { logger } from "../../utils/logger";

function safeTraverse(root, visitor) {
  if (!root || typeof visitor !== "function") return;
  const stack = [root];
  const seen = new Set();
  while (stack.length > 0) {
    const obj = stack.pop();
    if (!obj || seen.has(obj)) continue;
    seen.add(obj);
    visitor(obj);
    const children = obj.children;
    if (Array.isArray(children) && children.length > 0) {
      for (let i = children.length - 1; i >= 0; i--) stack.push(children[i]);
    }
  }
}

export function releaseAssetsInObject(root) {
  try {
    if (!root || typeof root.traverse !== "function") return;
    safeTraverse(root, (child) => {
      // Release mesh asset id if present
      try {
        const aId = child?.userData?.assetId;
        if (aId) releaseAsset(aId);
      } catch (error) {
        logger.warn("[assetUtils] Failed to release mesh asset id", error);
      }
      // Release any texture assets bound to materials on this mesh
      try {
        if (child && child.isMesh && child.material) {
          const materials = Array.isArray(child.material) ? child.material : [child.material];
          materials.forEach((m) => {
            const textureIds = new Set();
            if (m?.userData?.assetTextureId) textureIds.add(m.userData.assetTextureId);
            Object.values(m?.userData?.assetTextureIds || {}).forEach((id) => {
              if (id) textureIds.add(id);
            });
            textureIds.forEach((texId) => {
              try {
                releaseAsset(texId);
              } catch (error) {
                logger.warn("[assetUtils] Failed to release texture asset id", error);
              }
            });
            if (m.map) m.map = null;
            if (m.userData) {
              delete m.userData.assetTextureId;
              delete m.userData.assetTextureIds;
            }
            m.needsUpdate = true;
          });
        }
      } catch (error) {
        logger.warn("[assetUtils] Failed to release material assets", error);
      }
    });
  } catch (error) {
    logger.warn("[assetUtils] Failed to traverse object tree for asset release", error);
  }
}
